var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator text-center py-3"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.text))])]),(_vm.text)?_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }